import { render, staticRenderFns } from "./SAccordion.vue?vue&type=template&id=3d89e0b8&scoped=true&"
import script from "./SAccordion.vue?vue&type=script&lang=js&"
export * from "./SAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SAccordion.vue?vue&type=style&index=0&id=3d89e0b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89e0b8",
  null
  
)

export default component.exports